import React, { useEffect, useRef, useState } from 'react';

import styles from './Toaster.module.css';
import '../../css/common-forms.css';

const Toaster = ({ 
  show, 
  message, 
  type = 'error', 
  onClose, 
  autoHide = true, 
  autoHideDelay = 5000 
}) => {
  const timeoutRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    if (show) {
      setIsVisible(true);
      setIsFading(false);
      
      if (autoHide) {
        // Clear any existing timeout
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        
        // Set new timeout for fade out
        timeoutRef.current = setTimeout(() => {
          handleClose();
        }, autoHideDelay);
      }
    } else {
      setIsVisible(false);
      setIsFading(false);
    }
    
    // Cleanup on unmount or when show changes
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [show, autoHide, autoHideDelay]);

  const handleClose = () => {
    setIsFading(true);
    // Wait for fade out animation to complete before hiding
    setTimeout(() => {
      setIsVisible(false);
      onClose();
    }, 400);
  };

  if (!isVisible) return null;

  return (
    <div className={`${styles.toaster} ${styles[type]} ${isFading ? styles.fadeOut : ''}`}>
      <div className={styles.toasterContent}>
        {/* Show BoldSign icon only for the manual reminder limit message */}
        {type === 'error' && typeof message === 'string' && message.startsWith('Your manual reminders limit has been reached') && (
          <span className={styles.bsErrorIcon} aria-hidden="true"></span>
        )}
        <span className={styles.toasterMessage}>{message}</span>
        <button 
          className={styles.closeButton} 
          onClick={handleClose}
          aria-label="Close notification"
        >
          <span className={`${styles.closeIcon} sfIconBase sfCloseIcon`}></span>
        </button>
      </div>
    </div>
  );
};

export default Toaster;
